module.exports = __webpack_public_path__ + "static/media/kit.a686e8ea.svg";